export default __webpack_public_path__ + "static/award-1-cl-a3a8b4df3231e14393265af2f2464caf.png";